import React from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import { Divider, Typography, FormControlLabel, Switch } from '@mui/material'
import { styled } from '@mui/material/styles';
import MenuPerfil from '../loggin/MenuPerfil';
const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const ContenedorSetings = (props) => {
  const { open } = props
  const { appbar } = props
  const { cambiartema } = props
  const { darkestatus } = props

  return (
    <div>
      <AppBar position="absolute" color='info' open={open} elevation={0}>
        <Toolbar
          sx={{
            pr: '24px', // keep right padding when drawer closed
          }}
        >
          <IconButton
            edge="start"
            color='success'
            aria-label="open drawer"
            onClick={appbar}
            sx={{
              marginRight: '36px',
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <MenuPerfil />
        </Toolbar>
        <Divider />
      </AppBar>
      <br />
      <Typography>Control de incidencias v1.0</Typography>
      <Typography variant='overline'>Desarrollado por <a href='https://datwer.com' target="_blank">Datwer</a></Typography>
      <br />
      <FormControlLabel
        label="Tema modo oscuro"
        labelPlacement="end"

        control={
          <Switch
            color='success'
            value={darkestatus}
            checked={darkestatus}
            onChange={cambiartema}

          />
        }
      />
    </div>
  )
}

export default ContenedorSetings